import { getResolvedLiveSort, type LiveSortType } from '@module/helpers/live/getResolvedLiveSort';
import { create } from 'zustand';

interface LiveSortState {
  selectedSortType: LiveSortType | null;
  setSelectedSortType: (sortType: LiveSortType) => void;
  syncSelectedSortTypeFromSearch: (search: string) => void;
}

const parseSortTypeFromSearch = (search: string): LiveSortType | null => {
  const params = new URLSearchParams(search);
  const hasSortParams = params.has('onlyNewBj') || params.has('orderBy');

  if (!hasSortParams) return null;

  return getResolvedLiveSort(params).sortType;
};

const getInitialSelectedSortType = (): LiveSortType | null => {
  if (typeof window === 'undefined') return null;

  return parseSortTypeFromSearch(window.location.search);
};

const useLiveSortStore = create<LiveSortState>()((set) => ({
  selectedSortType: getInitialSelectedSortType(),
  setSelectedSortType: (sortType) => set({ selectedSortType: sortType }),
  syncSelectedSortTypeFromSearch: (search) => {
    set({ selectedSortType: parseSortTypeFromSearch(search) });
  },
}));

export default useLiveSortStore;
